import { useEffect, useState } from 'react';
import { authDestination, clearAuthReturn, rememberAuthReturn } from '../client/authContinuation';
import { validAuthReturn } from '../../shared/authContinuation';

export function useAuthProviders() {
  const [config, setConfig] = useState({ providers: [] });
  useEffect(() => {
    const controller = new AbortController();
    fetch('/api/auth/config', { signal: controller.signal })
      .then(response => response.ok ? response.json() : { providers: [] })
      .then(value => { if (!controller.signal.aborted) setConfig({ ...value, providers: Array.isArray(value.providers) ? value.providers.filter(p => ['google','github'].includes(p)) : [] }); })
      .catch(() => {});
    return () => controller.abort();
  }, []);
  return config;
}

export async function authPost(path, body, token = localStorage.getItem('token')) {
  const response = await fetch(`/api/auth/${path}`, { method: 'POST', credentials: 'include',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: JSON.stringify(body) });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw Object.assign(new Error(data.error || 'Could not continue. Please try again.'), { status: response.status });
  return data;
}

export async function completeBrowserSession(token, destination, setUserDetails, navigate) {
  const response = await fetch('/api/user/details', { headers: { Authorization: `Bearer ${token}` } });
  if (!response.ok) throw new Error('Could not load this account. Sign in again to continue.');
  const profile = await response.json();
  localStorage.setItem('token', token);
  window.dispatchEvent(new Event('storage'));
  setUserDetails(profile);
  const target = validAuthReturn(destination) || profile.signup_return_to || '/brief';
  if (profile.onboarding_pending) {
    rememberAuthReturn(target);
    navigate(authDestination('/authorization', target), { replace: true });
    return;
  }
  clearAuthReturn();
  if (target.startsWith('/oauth/resume?')) window.location.assign(target);
  else navigate(target, { replace: true });
}
